import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props<T extends string> {
  tabs: readonly T[];
  value: T;
  // 네임스페이스까지 포함한 전체 i18n 키
  labelKey: Record<T, string>;
  onChange: (tab: T) => void;
}

// 단일 선택 필터 탭 그룹. 두 모달이 같은 줄에 그룹을 나란히 두므로
// 스타일이 어긋나지 않게 한 컴포넌트로 모아 둔다.
function PathPickRequestFilterTabs<T extends string>({
  tabs,
  value,
  labelKey,
  onChange,
}: Props<T>) {
  const { t } = useI18nHelper();

  return (
    <Flex gap={"6px"} flexWrap={"wrap"}>
      {tabs.map((tab) => (
        <AppButton
          key={tab}
          variant={"white"}
          onClick={() => onChange(tab)}
          chakraProps={{
            padding: "10px",
            background: value === tab ? "rgb(247, 249, 250)" : "inherit",
            border: value === tab ? "1px solid #1272EF" : "0.5px solid #8F8F8C",
          }}
        >
          <Text textStyle={"body-sm-bold"} whiteSpace={"nowrap"}>
            {t(labelKey[tab])}
          </Text>
        </AppButton>
      ))}
    </Flex>
  );
}

export default PathPickRequestFilterTabs;
